//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export default function validateInstagramPermalink(permalink: string): boolean {
  // Match against Instagram Posts only
  // matches: https://www.instagram.com/p/my-post-url
  // doesn't match: https://www.instagram.com/habiliment/
  const pattern = /(^https:\/\/www.instagram.com\/p\/)/;

  return !!pattern.exec(permalink);
}

/**
 * Validates and extracts an Instagram URL for rights request purposes.
 * Matches URLs containing shortcodes after /p/, /tv/, /reel/, or /m/ (for Direct Messages) within Instagram URLs.
 *
 * @param url - The Instagram URL to validate
 * @returns The matched Instagram URL if valid, undefined otherwise
 *
 * @example
 * // Returns "https://www.instagram.com/p/ABC123"
 * validateInstagramUrlForRightsRequest("https://www.instagram.com/p/ABC123")
 *
 * @example
 * // Returns undefined
 * validateInstagramUrlForRightsRequest("https://invalid-url.com")
 */
export function validateInstagramUrlForRightsRequest(url: string) {
  // regex matching shortcode after /p/ or /tv/ or /reel/ within instagram url request for redirect and Added /m/ for Direct message
  // regex that only matches ASCII characters
  const instagramRegexMatch = url.match(
    /^https:\/\/(?:www\.)?instagram\.com(?:\/[\w.-]+)?\/(?:tv|p|m|reel)\/[\w.-]+\/?$/,
  );

  if (instagramRegexMatch) {
    return instagramRegexMatch[0];
  }
}
